import moment from "moment"

import countdown from "./countdown"

export const parseError = (data) => {
    var message = "";
    if (data.message === "Validation error") {
        message += data.message + ": ";

        data.data.map((item, index) => {
            return message += " " + (index > 0 ? ", " : "") + item.msg;
        })
    } else {
        message = data.message;
    }
    return message;
}

export const getAge = (val) => {
    var now = moment(moment().format("YYYY-MM-DD"))
    var birthdate = moment(moment(val).format("YYYY-MM-DD"));
    var check_days = moment(now).diff(birthdate, 'days');
    console.log(`${now} ${birthdate}`)

    if(check_days===0){
        return '0 day'
    }

    if (check_days < 7) {
        return countdown(birthdate, now, countdown.MONTHS | countdown.WEEKS | countdown.DAYS).toString()
        .toLowerCase().replace("months","month").replace("years","year").replace("days","day").replace("weeks","week").replace("and","/");
    }
    if(check_days>=7 && check_days<120){
             return countdown(birthdate, now, countdown.WEEKS).toString()
        .toLowerCase().replace("months","month").replace("years","year").replace("days","day").replace("weeks","week").replace("and","/");

    }
    // if (check_days <= 31) {
    //     return countdown(birthdate, new Date(), countdown.MONTHS | countdown.WEEKS).toString()
    //     .toLowerCase().replace("months","month").replace("years","year").replace("days","day").replace("and","/");
    // }


    return countdown(birthdate, now, countdown.YEARS | countdown.MONTHS).toString()
    .toLowerCase().replace("months","month").replace("years","year").replace("days","day").replace("weeks","week").replace("and","/");
}


export const format_website = (website) => {
    var str = website;
    str = str.replace(/http:\/\//, '');
    str = str.replace(/https:\/\//, '');

    str = str.split("/")[0];

    return str;
}
export const format_url = (website) => {
    if (website.indexOf("http://") === -1 && website.indexOf("https://") === -1) {
        return "https://" + website;
    }
    return website;
}
